import {
  phoneNumberOptionalValidation,
  REQUIRED_MESSAGE,
} from "@/pages/company/schema";
import { RoleEnum } from "@/types";
import z from "zod";

const UpdateUserSchema = z
  .object({
    role: z.enum(RoleEnum),
    full_name: z
      .string()
      .trim()
      .min(1, "ユーザー名を入力してください。")
      .max(255, "ユーザー名は225文字以下で入力してください。"),
    company_name: z
      .string()
      .trim()
      .max(255, "会社名は255文字以下で入力してください。")
      .optional(),
    position: z
      .string()
      .trim()
      .max(255, "役職は255文字以下で入力してください。")
      .optional(),
    department: z
      .string()
      .trim()
      .max(255, "部署は255文字以下で入力してください。")
      .optional(),
    email: z
      .string()
      .trim()
      .min(1, "メールアドレスを入力してください。")
      .refine((val) => z.email().safeParse(val).success, {
        message: "メールアドレスは無効な形式です。",
      })
      .max(
        255,
        "メールアドレス/パスワードは半角255文字以下で入力してください。"
      ),
    phone: phoneNumberOptionalValidation,
    address: z
      .string()
      .trim()
      .max(255, "住所は255文字以下で入力してください。")
      .optional(),
    store_id: z.number().optional(),
    group_ids: z.array(z.number()).optional(),
  })
  .refine(
    (data) => {
      // In case role is USER or STORE_MANAGER, store_id is required
      if ([RoleEnum.USER, RoleEnum.STORE_MANAGER].includes(data.role)) {
        return data.store_id !== undefined;
      }
      return true;
    },
    {
      message: REQUIRED_MESSAGE,
      path: ["store_id"],
    }
  );

export { UpdateUserSchema };
